<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="false" />
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <!-- 以下内容 -->
            <div class="col-sm-12">
                <div class="row mypage-info-record">
                    <div class="col-md-3 col-lg-3">お名前カナ</div>
                    <div class="col-lg-4 text-right text-sm-left break-all">{{ from_set_data.full_name_kana }}</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-md-3 col-lg-3">お名前</div>
                    <div class="col-lg-4 text-right text-sm-left break-all">{{ from_set_data.full_name }}</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-sm-3 align-self-center">性別</div>
                    <div class="col-sm-6 text-right text-sm-left align-self-center">{{ from_set_data.gender }}</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-lg-3 align-self-center">生年月日</div>
                    <div class="col-lg-6 text-right text-lg-left align-self-center">{{ from_set_data.birth_date | replace('-','/') }}</div>
                    <div class="col-lg-3 ml-md-auto mr-md-auto mr-lg-0 text-center mt-3 mt-lg-0">
                        <div class="pcview">
                            <button type="button" class="bluebackbutton col-btn-size" v-on:click="GotoInfoChange()" v-if="!this.access_from_line">変更</button>
                        </div>
                    </div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-md-3 col-lg-3">郵便番号</div>
                    <div class="col-lg-4 text-right text-sm-left break-all">{{ zipCodeFormat(from_set_data.zipcode) }}</div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-md-3 col-lg-3">住所</div>
                    <div class="col-lg-4 text-right text-sm-left break-all">{{ from_set_data.address1 }}</div>
                </div>
                <div class="row mypage-info-record pb-3 mypage-gray-border-bottom">
                    <div class="col-md-3 col-lg-3"></div>
                    <div class="col-lg-4 text-right text-sm-left break-all">{{ from_set_data.address2 }}</div>
                    <div class="col-lg-3 ml-md-auto mr-md-auto mr-lg-0 text-center mt-3 mt-lg-0 spview">
                        <button type="button" class="bluebackbutton col-btn-size" v-on:click="GotoInfoChange()" v-if="!this.access_from_line">変更</button>
                    </div>
                </div>
                <div class="row mypage-info-record pb-3 mypage-gray-border-bottom">
                    <div class="col-sm-3">携帯番号</div>
                    <div class="col-sm-4 col-md-6 col-lg-4 text-right text-sm-left break-all">{{ formatSP(from_set_data.mobile_number) }}</div>
                    <div class="col-lg-3 ml-md-auto mr-md-auto mr-lg-0 text-center mt-3 mt-lg-0">
                        <button type="button" class="bluebackbutton col-btn-size" v-on:click="GotoMobileChange()" v-if="!this.access_from_line">変更</button>
                    </div>
                </div>
                <div class="row mypage-info-record pb-3 mypage-gray-border-bottom">
                    <div class="col-md-3 col-lg-3">メールアドレス</div>
                    <div class="col-sm-4 col-md-6 col-lg-4 text-right text-sm-left break-all">{{ from_set_data.email }}</div>
                    <div class="col-lg-3 ml-md-auto mr-md-auto mr-lg-0 text-center mt-3 mt-lg-0">
                        <button type="button" class="bluebackbutton col-btn-size" v-on:click="GotoMemberSetting()" v-if="!this.access_from_line">変更</button>
                    </div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-md-3 col-lg-3">パスワード</div>
                    <div class="col-sm-4 col-md-6 col-lg-4 text-right text-sm-left break-all">**********</div>
                    <div class="col-lg-3 ml-md-auto mr-md-auto mr-lg-0 text-center mt-3 mt-lg-0">
                        <button type="button" class="bluebackbutton col-btn-size" v-on:click="GotoPasswordChange()" v-if="!this.access_from_line">変更</button>
                    </div>
                </div>
                <div class="row mypage-info-record">
                    <div class="col-lg-3 ml-md-auto mr-md-auto text-center py-2">
                        <button type="button" class="mypagebackbutton footer-btn-size" v-on:click="GotoMemberQuit()" v-if="!this.access_from_line">会員を退会する</button>
                    </div>
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import MypageHeader from './MypageHeader';
import MypageFooter from './MypageFooter';
import Card from '../components/Card';
import { GET_MEMBER_ID } from '../../constants/signin';
import { GET_MEMBER } from '../../constants/mypage_info';
import { memberStatusMixin } from './memberStatusMixin';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        MypageFooter,
        Card
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            page_title: '会員情報参照・変更',
            member_no: '',
            access_from_line: false,
            from_set_data: {
                // 会員番号
                member_no: '',
                // フルネーム
                full_name: '',
                // フルネーム（カナ）
                full_name_kana: '',
                // 性別
                gender: '',
                // 生年月日
                birth_date: '',
                // 携帯番号
                mobile_number: '',
                // メールアドレス
                email: '',
                // 郵便番号
                zipcode: '',
                // 住所1
                address1: '',
                // 住所2
                address2: '',
            },
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.GetLoginUserMemberStatus();
            // LINEリッチメニューからの遷移の場合
            if (this.$route.query.access_from_line) {
                this.access_from_line = true;
                this.page_title = '会員情報参照';
            }
            try {
                await this.setMember();
            } catch(err) {
                console.log("エラーが起こりました:" + err)
            }
        },
        /** --------------------------------------------
         * 会員情報を取得
         * -------------------------------------------- */
        setMember: function () {
            this.from_set_data.member_no = this.$store.state.auth.loginMember.member_no;
            this.from_set_data.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            if (this.$store.state.auth.loginMember.family_name_kana && this.$store.state.auth.loginMember.given_name_kana) {
                this.from_set_data.full_name_kana = this.$store.state.auth.loginMember.family_name_kana + ' ' + this.$store.state.auth.loginMember.given_name_kana;
            }
            if (this.$store.state.auth.loginMember.gender === 0) {
                this.from_set_data.gender = '男性';
            } else if (this.$store.state.auth.loginMember.gender === 1) {
                this.from_set_data.gender = '女性';
            }
            this.from_set_data.zipcode = this.$store.state.auth.loginMember.zipcode;
            this.from_set_data.address1 = this.$store.state.auth.loginMember.address1;
            this.from_set_data.address2 = this.$store.state.auth.loginMember.address2;
            this.from_set_data.birth_date = this.$store.state.auth.loginMember.birth_date;
            this.from_set_data.mobile_number = this.$store.state.auth.loginMember.mobile_number;
            this.from_set_data.email = this.$store.state.auth.loginMember.email;
        },
        GotoPasswordChange: function (){
            // パスワード変更画面へ遷移
            this.$router.push({ path: '/mypage-passchange' });
        },
        GotoInfoChange: function () {
            // 会員名前（姓）変更画面へ遷移
            this.$router.push({ path: '/mypage-info-change' });
        },
        GotoMobileChange: function (){
            // 携帯番号変更画面へ遷移
            this.$router.push({ path: '/mypage-mobile-change' });
        },
        GotoMemberSetting: function (){
            // 会員情報の変更画面へ遷移
            this.$router.push({ path: '/mypage-member-setting' });
        },
        GotoMemberQuit: function (){
            // 会員退会画面へ遷移
            this.$router.push({ path: '/mypage-quit' });
        },
        formatSP(number){
            if (number != null){
                if (number.length == 11) {
                    return number.substr(0,3) + "-" + number.substr(3,4) + "-" + number.substr(7,4);
                }
            }
            return number
        },
        /** --------------------------------------------
         * ハイフン無しの郵便番号を012-3456形式に変換する
         * @param zipCode 対象の郵便番号
         * -------------------------------------------- */
        zipCodeFormat: function (zipCpde) {
            if (zipCpde) {
                var before = zipCpde.substring( 0, 3 );
                var after = zipCpde.substring( 3, 7 );
                return before + '-' + after;
            }
            return '';
        }
    }
}

</script>

<style scoped>
</style>
